/* eslint-disable no-nested-ternary */

import Loading from "components/Loading"

import { ComponentProps } from "."
import { Wrapper } from "./styled"

const Button = ({
  ariaLabel,
  asProp,
  bold,
  children,
  className,
  color,
  disabled,
  expanded,
  href,
  iconOnly,
  icon,
  iconEnd,
  iconStart,
  label,
  loading,
  noHoverHighlight,
  noPadding,
  onClick,
  outlined,
  padded,
  raised,
  rounded,
  secondary,
  small,
  title,
  transparent,
  type = "button"
}: ComponentProps) => (
  <Wrapper
    $bold={bold}
    $color={color}
    $expanded={expanded}
    $hasIconEnd={Boolean(iconEnd)}
    $hasIconStart={Boolean(iconStart)}
    $iconOnly={iconOnly}
    $loading={loading}
    $noHoverHighlight={noHoverHighlight}
    $noPadding={noPadding}
    $outlined={outlined}
    $padded={padded}
    $raised={raised}
    $rounded={rounded}
    $secondary={secondary}
    $small={small}
    $transparent={transparent}
    aria-disabled={disabled ? "true" : "false"}
    aria-label={ariaLabel ? ariaLabel : iconOnly ? label : undefined}
    as={asProp}
    className={className}
    disabled={disabled}
    href={href}
    onClick={onClick}
    title={
      title ? title : iconOnly ? (ariaLabel ? ariaLabel : label) : undefined
    }
    type={type}
  >
    {iconOnly ? icon : null}

    {iconOnly ? null : !iconOnly && iconStart ? iconStart : <span />}

    {iconOnly ? null : children ? children : label}

    {iconOnly ? null : !iconOnly && iconEnd ? iconEnd : <span />}

    {loading ? <Loading contrast={!outlined} /> : null}
  </Wrapper>
)

export default Button
